<template>
  <base-dialog :showDialog="showDialog">
    <template v-slot:body>
      <v-sheet v-if="isLoading" class="pa-3" dark>
        <v-skeleton-loader
          class="mx-auto"
          max-height="768"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>
      <v-card dark v-else>
        <v-card-title>
          <div class="d-flex justify-space-around">
            <span class="text-h6">Item Integração</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="4">
              <c-input
                label="Código"
                placeholder="Código Megabit"
                :readonly="true"
                v-model="item.codigo"
              />
            </v-col>
            <v-col>
              <c-input
                label="Descrição"
                placeholder="Descrição Produto"
                :readonly="true"
                v-model="item.descricao"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <c-input
                label="Código Integração"
                placeholder="Código Integração"
                type="number"
                v-model="item.idItemIntegracao"
              />
            </v-col>
            <v-col cols="4">
              <c-input
                label="Estoque Minimo"
                placeholder="Estoque Minimo"
                type="number"
                v-model="item.estoqueMinimo"
              />
            </v-col>
            <v-col cols="4">
              <c-input
                label="Prazo Disponibilidade"
                placeholder="Digite em dias"
                type="number"
                v-model="item.prazoDisponibilidade"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="5">
              <c-input-money
                v-model="item.preco"
                label="Preço"
                dark
                dense
                outlined
                reverse
                :hint="
                  `Preço ${descricaoTipoPreco} :  ${parseFloat(
                    item.precoVarejo
                  ).toFixed(2)}`
                "
                v-bind:valueWhenIsEmpty="'0'"
                v-bind:options="{
                  locale: 'pt-BR',
                  prefix: '',
                  suffix: systemCurrency[0].cifrao,
                  length: 11,
                  precision: `${getQntDecimais(systemCurrency[0])}`,
                }"
              />
            </v-col>
            <v-col>
              <v-combobox
                dark
                dense
                outlined
                label="Fabricante"
                placeholder="Selecionar Fabricante"
                class="text-caption mx-1"
                v-model="item.fabricanteIntegracao"
                :items="manufacturerComboBox"
                item-text="NOME"
                item-value="NOME"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <c-select-multiple
                :rotulo="'Selecionar Categorias'"
                itemText="NOME"
                itemValue="ID"
                :lista="categoryComboBox"
                :item.sync="item.categorias"
                v-model="item.categorias"
                :isChips="false"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-switch
                color="success"
                dark
                dense
                outlined
                label="Selo Lançamento"
                class="customClass"
                v-model="item.isSeloLancamento"
              />
              <v-switch
                color="success"
                dark
                dense
                outlined
                label="Selo Destaque"
                class="customClass"
                v-model="item.isSeloDestaque"
              />
            </v-col>
            <v-col>
              <v-switch
                color="success"
                dark
                dense
                outlined
                label="Selo Adicional"
                class="customClass"
                v-model="item.isSeloAdicional"
              />
              <v-switch
                color="success"
                dark
                dense
                outlined
                label="Marcar Produto sob Consulta"
                class="customClass ml-2"
                v-model="item.isProdutoSobConsulta"
              />
              <v-switch
                color="success"
                dark
                dense
                outlined
                label="Produto Ativo"
                class="customClass ml-2"
                v-model="item.vendaInternet"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <form-buttons
          @goBack="$emit('goBack')"
          @submitForm="submitForm(item, 'form')"
        />
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import FormButtons from '../../../shared/base-buttons/FormButtons.vue'
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput.vue'
import cInputMoney from '@/components/shared/base-input/BaseInputMoney.vue'

import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  components: {
    FormButtons,
    BaseDialog,
    cInputMoney,
    cInput,
    cSelectMultiple: () =>
      import('@/components/shared/base-input/BaseSelectMultiple'),
  },
  computed: {
    ...mapGetters({
      categoryComboBox: 'trayModule/getCategoryComboBox',
      manufacturerComboBox: 'trayModule/getManufacturerComboBox',
      systemCurrency: 'systemModule/getSystemCurrencies',
    }),
    ...mapState('currencyModule', ['currency']),

    descricaoTipoPreco() {
      return this.integration?.TIPOPRECO || 'Varejo'
    },
  },
  data: () => {
    return {
      item: {},
      isLoading: true,
    }
  },
  methods: {
    ...mapActions('trayModule', [
      'getProductIntegration',
      'getCategoriesIntegration',
      'getManufacturersIntegration',
      'translateProductFromFirebird',
    ]),

    async fetch() {
      try {
        await this.getCategoriesIntegration({ todos: 'S' })
        await this.getManufacturersIntegration({ todos: 'S' })
        var obj = await this.translateProductFromFirebird(this.objectData)

        if (this.objectData.CODIGO.length > 0 && this.objectData.INTEGRACAO) {
          let item = await this.getProductIntegration(obj.codigo)

          if (item)
            this.item = {
              ...item,
            }
        } else
          this.item = {
            ...obj,
          }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
      this.isLoading = false
    },
    getQntDecimais(currency) {
      return currency.mascara.indexOf('.') != -1 ? 2 : 0
    },
  },
  mounted() {
    this.fetch()
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    objectData: {
      type: Object,
      default: () => {},
      required: true,
    },
    integration: {
      type: Object,
      default: () => {},
      required: true,
    },
    submitForm: {
      type: Function,
    },
  },
}
</script>

<style lang="css" scoped>
.customClass >>> label {
  font-size: 0.9em;
}
</style>
